import { observer } from 'mobx-react';
import * as React from 'react';
import { T, translation, TranslationsContext } from '../../../../../../Translations';
import { shareStore } from '../../Stores/ShareStore';

const AdvancedSettings: React.FC = () => {
  if (shareStore.state.kind !== 'ready') {
    return null;
  }

  return (
    <div>
      <h4 className="font-semibold text-sm mb-4">
        What should be the experience for unlicensed users who get a URL?
      </h4>

      <div className="space-y-3">
        <label className="text-sm flex items-start">
          <input
            type="radio"
            name="unlicensedAccess"
            value="block"
            checked={shareStore.state.unlicensedAccess === 'block'}
            onChange={() => shareStore.updateUnlicensedAccess('block')}
            className="mt-1 mr-3 text-teal-600"
          />
          <T kind="Block access" />
        </label>

        <label className="text-sm flex items-start">
          <input
            type="radio"
            name="unlicensedAccess"
            value="read-only"
            checked={shareStore.state.unlicensedAccess === 'read-only'}
            onChange={() => shareStore.updateUnlicensedAccess('read-only')}
            className="mt-1 mr-3 text-teal-600"
          />
          <T kind="Allow read-only access" />
        </label>

        <div>
          <label className="text-sm flex items-start">
            <input
              type="radio"
              name="unlicensedAccess"
              value="allocate"
              checked={shareStore.state.unlicensedAccess === 'allocate'}
              onChange={() => shareStore.updateUnlicensedAccess('allocate')}
              className="mt-1 mr-3 text-teal-600"
            />
            <div className="flex-1">
              <div className="mb-2">
                <T kind="Allocate a license" />
              </div>
            </div>
          </label>

          {shareStore.state.unlicensedAccess === 'allocate' && (
            <select
              className="mt-3 text-sm w-full border border-gray-300 rounded-md pl-3 pr-9 py-2 truncate"
              value={shareStore.state.selectedLicenseId.cata({
                Just: (id) => id.toString(),
                Nothing: () => '',
              })}
              onChange={(e) => {
                if (e.target.value !== '') {
                  shareStore.updateSelectedLicense(parseInt(e.target.value, 10));
                }
              }}
            >
              {/*
               * <option> children must be plain text — React elements
               * (e.g. <T>) break the native <select> render. Consume the
               * TranslationsContext to resolve translation keys to plain
               * strings and interpolate them alongside the license fields.
               * DVLP-7559.
               */}
              <TranslationsContext.Consumer>
                {(ts) => (
                  <>
                    <option value="" disabled>
                      {translation('Select a License')(ts)}
                    </option>
                    {shareStore.availableLicenses.map((license) => {
                      const endOnDisplay =
                        license.endOn instanceof Date && !isNaN(license.endOn.getTime())
                          ? license.endOn.toLocaleDateString()
                          : '';
                      const suffix = endOnDisplay
                        ? ` - ${translation('ends on')(ts)} ${endOnDisplay}`
                        : '';
                      return (
                        <option key={license.id} value={license.id.toString()}>
                          {license.licenseTypeName} - {license.quantityAvailable}{' '}
                          {translation('remaining')(ts)}
                          {suffix}
                        </option>
                      );
                    })}
                  </>
                )}
              </TranslationsContext.Consumer>
            </select>
          )}
        </div>
      </div>
    </div>
  );
};

export default observer(AdvancedSettings);
